const _BATTLECHECK = 5000;
const _STARTBATTLE = 1000;
const _FLIP = 1000;

Vue.component('battleArena', {
  template: templates.battleArena,
  data() {
    return {
      model: {
        id:  null,
        cards1: [],
        cards2: [],
        index1: 0,
        index2: 0,
        user1: {
          twitchId: null,
          twitchDisplayName: null,
          twitchProfileImage: null
        },
        user2: {
          twitchId: null,
          twitchDisplayName: null,
          twitchProfileImage: null
        },
        battleLoaded: false,
        abilities: [],
        settings: {},
        stolenCard: null,
        show: {
          winner: false,
          cards: false,
          stolenCard: false,
          users: false,
          move: false,
          logs: false
        },
        audio: {},
        logs: [],
        events: []
      }
    }
  },
  mounted() {
    const c = this;

    c.setupSounds();
    c.getSettings();
    c.getAbilities();
  },
  methods: {
    stop() {
      const c = this;
      c.playerDefeated(1);
    },
    setupSounds() {
      const c = this;

      c.model.audio.hit = new Audio('../audio/hit.mp3');
      c.model.audio.flip = new Audio('../audio/card-flip.mp3');
      c.model.audio.move = new Audio('../audio/whoosh-02.mp3');
      c.model.audio.win = new Audio('../audio/award-01.mp3');
    },
    getSettings() {
      const c = this;
      
      let data = {};

      settingsService.get()
        .then(function (response) {
          for (let d of response.data) {
            data[`${d.key}`] = d;
          }
          c.model.settings = data;

          setTimeout(function() {
            c.getSettings();
          }, 30000);
        })
        .catch(function (error) {
          
        });

    },
    stupidLog(message) {
      $('.stupid-log').prepend(`<p>${message}</p>`);
    },
    getAbilities() {
      const c = this;
      let data = {};

      abilityService.get()
        .then(function (response) {
          for (let d of response.data) {
            data[`${d.id}`] = d;
          }
        
          c.model.abilities = data;
          c.getBattles();
        })
        .catch(function (error) {
          getAbilities();
        });
    },
    getStatus() {
      const c = this;

      battleService.getStatus(c.model.id)
        .then(function (response) {
          if (response.data.deleted || response.data.queue) {
            window.location.reload();
          }
        
          setTimeout(function() {
            c.getStatus();
          }, 4000);
        })
        .catch(function (error) {
          
        });
    },
    getBattles() {
      const c = this;

      //Prevent calling api while a battle is happening
      if (c.model.battleLoaded) {
        return;
      }

      //TODO refactor this at some point
      if (c.model.settings.autobattle && c.model.settings.autobattle.value) {

        //Get active battle
        battleService.getAuto()
          .then(function (response) {
            let data = response.data[0];

            if (c.model.id != data.id) {
              c.model.battleLoaded = true;
              c.processBattle(data);
              c.getTwitchUsers()
            }

          })
          .catch(function (error) {
            setTimeout(function() {
              c.getBattles();
            }, _BATTLECHECK);
          });

      } else {

        //Get active battle
        battleService.getActive()
          .then(function (response) {
            let data = response.data[0];

            if (c.model.id != data.id) {
              c.model.battleLoaded = true;
              c.processBattle(data);
              c.getTwitchUsers()
            }

          })
          .catch(function (error) {
            setTimeout(function() {
              c.getBattles();
            }, _BATTLECHECK);
          });

      }
    },
    //Add cards to model and get twitch info
    processBattle(data) {
      const c = this;

      c.model.id = data.id;

      c.getStatus();

      let cards1 = playingCards.getCardsStats(data.user1Cards, c.model.abilities);
      let cards2 = playingCards.getCardsStats(data.user2Cards, c.model.abilities);

      c.model.cards1 = cards1;
      c.model.cards2 = cards2;
      
      c.getTwitchInfo(data);
    },
    //Get battling users twitch info
    getTwitchInfo(data) {
      const c = this;
  
      twitchAPI.getUsersById([{twitchId: data.user1TwitchId}, {twitchId: data.user2TwitchId}], function(userData) {
  
        for (let d of userData) {
  
          let user = {
            twitchId: d.id,
            twitchDisplayName: d.display_name,
            twitchProfileImage: d.profile_image_url
          }
  
          if (data.user1TwitchId == user.twitchId) {
            c.model.user1 = user;
          } else if (data.user2TwitchId == user.twitchId) {
            c.model.user2 = user;
          }
          
        }
  
        setTimeout(function() {
          c.startBattle();
        }, _STARTBATTLE);
  
      });
    },
    //Start battle by flipping first cards and applying the initial abilities
    startBattle: function() {
      const c = this;

      //c.model.show.battle = true;

      c.showStats();

      setTimeout(function() {
        c.model.show.users = true;

        setTimeout(function() {
          c.model.show.move = true;

          setTimeout(function() {
            c.model.show.cards = true;

            setTimeout(function() {
              c.flip(c.model.cards1[0], 0);
              c.flip(c.model.cards2[0], 0);
              c.model.audio.flip.play();

              //TODO seems like this isn't supposed to be here
              // c.applyTurnAbiltiy(c.model.cards1[0], c.model.cards2, c.model.cards1);
              // c.applyTurnAbiltiy(c.model.cards2[0], c.model.cards2, c.model.cards1);

              setTimeout(function() {
                c.applyInitialAbilities(c.model.cards1, c.model.cards2, c.model.index1, c.model.index2);
                c.applyInitialAbilities(c.model.cards2, c.model.cards1, c.model.index2, c.model.index1);
                c.applyTurnAbiltiy(c.model.cards1[0], c.model.cards1, c.model.cards2, c.model.index1, c.model.index2);
                c.applyTurnAbiltiy(c.model.cards2[0], c.model.cards2, c.model.cards1, c.model.index2, c.model.index1);
                c.startRound(Math.random());
              }, 1500);
            }, 1000);
          }, 1000);
        }, 1500)
      }, 500)

    },
    //Apply abilities for abilities that fire at the beginning of the battle
    applyInitialAbilities: function(cards1, cards2, index1, index2) {
      const c = this;

      for (let card of cards1) {
        try {
          if (card.abilityKey && typeof abilities.initial[`${card.abilityKey}`] === 'function') {
            abilities.initial[`${card.abilityKey}`](cards1, cards2, index1, index2, c.model.events);
            c.logEvent(`${card.name} used ${card.ability}!`);
          }
        }
        catch(err) {
          c.logError(`${card.ability} through an error`);
        }
      }

      //c.startRound(Math.random());
    },
    startRound(first) {
      const c = this;
    
      if (c.model.cards1.length > c.model.index1 && c.model.cards2.length > c.model.index2) {
        let totalMoveCount = 0;
        let moveCount1 = c.getAttachCount(c.model.cards1[c.model.index1]);
        let moveCount2 = c.getAttachCount(c.model.cards2[c.model.index2]);
        totalMoveCount += moveCount1;
        totalMoveCount += moveCount2;

        // Randomly choose which card attacks first
        // Card 1 goes first
        if (first < .5) {

          for (let i = 0; i < moveCount1; i++) {
            setTimeout(function() { 
              if (c.attemptAttack(c.model.cards1[c.model.index1], c.model.cards2[c.model.index2], c.model.cards1, c.model.cards2, c.model.index1, c.model.index2)) {
                c.model.index2 += 1;
                c.flip(c.model.cards2[c.model.index2]);
                setTimeout(function() {
                  c.applyTurnAbiltiy(c.model.cards2[c.model.index2], c.model.cards2, c.model.cards1, c.model.index2, c.model.index1);
                }, _FLIP);
              }
            }, 1000 * i);
          }

          setTimeout(function() { 

            for (let i = 0; i < moveCount2; i++) {
              setTimeout(function() { 
                if (c.attemptAttack(c.model.cards2[c.model.index2], c.model.cards1[c.model.index1], c.model.cards2, c.model.cards1, c.model.index2, c.model.index1)) {
                  c.model.index1 += 1;
                  c.flip(c.model.cards1[c.model.index1]);
                  setTimeout(function() {
                    c.applyTurnAbiltiy(c.model.cards1[c.model.index1], c.model.cards1, c.model.cards2, c.model.index1, c.model.index2);
                  }, _FLIP);
                }
              }, 1000 * i);
            }

          }, 1250 * moveCount1);
          
        // Card 2 goes first
        } else {

          for (let i = 0; i < moveCount2; i++) {
            setTimeout(function() { 
              if (c.attemptAttack(c.model.cards2[c.model.index2], c.model.cards1[c.model.index1], c.model.cards2, c.model.cards1, c.model.index2, c.model.index1)) {
                c.model.index1 += 1;
                c.flip(c.model.cards1[c.model.index1]);
                setTimeout(function() {
                  c.applyTurnAbiltiy(c.model.cards1[c.model.index1], c.model.cards1, c.model.cards2, c.model.index1, c.model.index2);
                }, _FLIP);
              }
            }, 1000 * i);
          }

          setTimeout(function() { 

            for (let i = 0; i < moveCount1; i++) {
              setTimeout(function() { 
                if (c.attemptAttack(c.model.cards1[c.model.index1], c.model.cards2[c.model.index2], c.model.cards1, c.model.cards2, c.model.index1, c.model.index2)) {
                  c.model.index2 += 1;
                  c.flip(c.model.cards2[c.model.index2]);
                  setTimeout(function() {
                    c.applyTurnAbiltiy(c.model.cards2[c.model.index2], c.model.cards2, c.model.cards1, c.model.index2, c.model.index1);
                  }, _FLIP);
                }
              }, 1000 * i);
            }
          }, 1250 * moveCount2);
    
        }

        setTimeout(function() {  
          c.startRound(c.model.cards1, c.model.cards2, c.model.index1, c.model.index2, first);
        }, 2500 * (totalMoveCount - 1));

        return;
    
      }
    
      if (c.model.index2 == c.model.cards2.length) {
        c.playerDefeated(2);
        return 1;
      } else {
        c.playerDefeated(1);
        return 2;
      }
    },
    applyTurnAbiltiy(card, cards1, cards2, index1, index2) {
      const c = this;
      try {
        if (card && card.abilityKey && typeof abilities.turn[`${card.abilityKey}`] === 'function') {
          abilities.turn[`${card.abilityKey}`](cards1, cards2, index1, index2, c.model.events);
          c.logEvent(`${card.name} used ${card.ability}!`);
        }
      }
      catch(err) {
        c.logError(`${card.ability} through an error`);
      }
    },
    attemptAttack(card1, card2, cards1, cards2, index1, index2) {
      const c = this;

      if (!card1 || !card2) {
        return false;
      }
      
      if (card1.turnSkips > 0) {
        card1.turnSkips -= 1;
        c.saveEvent({cardId: card.id, skipped: true});
        c.logEvent(`${card1.name}'s turn was skipped`);
        return false;
      }

      c.model.audio.move.play();

      try {
        if (typeof abilities.move[`${card1.abilityKey}`] === 'function') {
          abilities.move[`${card1.abilityKey}`](cards1, cards2, index1, index2, c.model.events);
          c.logEvent(`${card1.name} used ${card1.ability}!`);
        }
      }
      catch(err) {
        c.logError(`${card1.ability} through an error`);
      }

      c.cardAttack(card1);
      let cardHp = card2.hp;

      let attachNumber = Math.random() * 100;
    
      if (attachNumber < Number(card1.accuracy)) {

        //Get min damage of between 50 - 250;
        const randomDamage = Math.floor(Math.random() * 200) + 50;
        const initialDamage = Math.max(randomDamage, Number(card1.attack) - Number(card2.defence));

        //Get a percent of the total damage to slightly randomize total damage
        let damageVariancePercent = Math.floor(Math.random() * (100 - 75) + 75);
        //Caculate the chance for a critical 30% chance
        const criticalChance = Math.floor(Math.random() * 10) + 1;
        let critical = false;

        if (criticalChance < card1.criticalChance) {
          critical = true;
          //Critical damage varies from 101 - 120%
          damageVariancePercent = 100 + (Math.floor(Math.random() * (20 - 1) + 1));
        }

        //Get new damage ammount
        const variedDamage = Math.round((damageVariancePercent / 100) * initialDamage);
        
        cardHp -= variedDamage;
        
        c.saveEvent({cardId: card1.id, damage: variedDamage, critical: critical});
        c.damageTaken(card2, variedDamage, critical, cards1, cards2, index1, index2);
      } else {
        c.saveEvent({cardId: card1.id, missed: true});
        c.logEvent(`${card1.name} missed it's attach`);
      }
      if (cardHp <= 0) {
        c.cardDefeated(card2);
        return true;
      }
      
      return false;
    },
    cardAttack(card) {
      let $card = $(`#${card.id}`).find('.playing-card-wrapper');
      $card.addClass('attack');

      setTimeout(function() {
        $card.removeClass('attack');
      }, 1200);
    },
    damageTaken(card, damage, critical, cards1, cards2, index1, index2) {
      const c = this;
      let $card = $(`#${card.id}`);

      let $hpLost = $(`<span class="hp-lost">-${damage}</span>`);
      $card.append($hpLost);
      $card.find('.playing-card-wrapper').addClass('-shakeX');

      if (critical) {
        $card.find('.playing-card-wrapper').addClass('-flash');
      }

      c.logEvent(`${card.name} took ${damage} damage`);

      setTimeout(function() {
        //So the visual hp on the card doesn't go below 0
        if (card.hp - damage < 0) {
          card.hp = 0;
        } else {
          card.hp -= damage;

          try {
            if (typeof abilities.damaged[`${card.abilityKey}`] === 'function') {
              abilities.damaged[`${card.abilityKey}`](cards2, cards1, index2, index1, damage, c.model.events);
              c.logEvent(`${card.name} used ${card.ability}!`);
            }
          }
          catch(err) {
            c.logError(`${card.ability} through an error`);
          }
          
        }

        c.model.audio.hit.play();
        
        $hpLost.addClass('show');
        $card.find('.playing-card-wrapper').removeClass('-shakeX -flash');
      }, 300);

      setTimeout(function() {
        $hpLost.addClass('remove');

        setTimeout(function() {
          $hpLost.remove();
        }, 3000);
      }, 1300);
    },
    cardDefeated(card) {
      let c = this;
      //setTimeout(function() {
        let $card = $(`#${card.id}`);
        $card.addClass('remove');

        setTimeout(function() {
          $card.remove();
        }, 1000);
      //}, 1000);

      c.saveEvent({cardId: card.id, defeated: true});
      c.logEvent(`${card.name} was defeated!`);
    },
    playerDefeated(player) {
      const c = this;
      
      c.logEvent(`Player ${player} was defeated!`);
      
      c.model.battleLoaded = false;
      c.model.show.cards = false;
      c.model.show.users = false;

      const $user = $(`.user.user${player == 1 ? 2 : 1}`).clone();
      $('.winner div').html('').append($user);
      c.model.show.winner = true; 

      c.model.audio.win.play();

      const winnerTwitchId = player == 1 ? c.model.user2.twitchId : c.model.user1.twitchId;

      let data = {
        id: c.model.id, 
        winnerTwitchId: winnerTwitchId,
        events: c.model.events
      };

      setTimeout(function() {
        c.model.show.winner = false;

         if (c.model.settings.autobattle && c.model.settings.stealcards.value) {
          c.model.stolenCard = c.stealCard(player == 1 ? c.model.cards1 : c.model.cards2);
          data.stolenCardId = c.model.stolenCard.id;
  
          setTimeout(function() {
            c.showStats();
            c.model.show.stolenCard = true;
            c.flip(c.model.stolenCard);

            setTimeout(function() {
              c.model.show.stolenCard = false;
              setTimeout(function() {
                c.saveBattle(data);
              }, 500);
            }, 3500);
          }, 1500);
        } else {
          c.saveBattle(data);
        }
      }, 3500);
      
    },
    saveBattle(data) {
      const c = this;
      battleService.save(data)
        .then(function (response) {
          
          setTimeout(function() {
            c.model.stolenCard = null;
            window.location.reload();
          }, 8000);
          
        })
        .catch(function (error) {
          c.logEvent(error);
        });
    },
    showStats() {
      $('.info').removeClass('is-visible');
      $('.bottom').removeClass('is-hidden');
    },
    saveEvent(data) {
      const c = this;
      data.battleId = c.model.id;
      c.model.events.push(data);
    },
    logEvent(message) {
      const c = this;
      console.log(message);
      c.model.show.logs = true;
      setTimeout(function() {
        c.model.logs.unshift(message);
        c.model.logs = c.model.logs.slice(0, 10);
      }, 300);
    },
    logError(message) {
      const c = this;
      logService.save({message: message})
        .then(function (response) { })
        .catch(function (error) { });
    },
    stealCard(cards) {
      const index = Math.floor(Math.random() * cards.length);
      return cards[index];
    },
    getAttachCount(card) {
      const c = this;
      const maxSpeed = 6000;
      const cardSpeed = card.speed;

      if (cardSpeed == maxSpeed) {
        maxSpeed = maxSpeed * 1.2;
      }

      let chance = (cardSpeed / maxSpeed) / 3; 
      chance = Math.round(chance * 100) / 100;

      if (Math.random() < chance) {
        return 2;
      }

      return 1;

    },
    flip(card, timeout = _FLIP) {
      const c = this;
      if (!card) return;
      setTimeout(function() {
        let id = card.id;
        c.$root.$emit(`flip${id}`, id);
        c.model.audio.flip.play();
      }, timeout);
    },
  }
})